import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faBold,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faDownload,
  faItalic,
  faList,
  faListOl,
  faMinusCircle,
  faPen,
  faPlus,
  faPlusCircle,
  faSpinner,
  faStrikethrough,
  faTrash,
  faUnderline,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueFormGenerator from 'vue-form-generator';
import configureFilters from '@/configureFilters';
import vfgFieldCustomChecklist from './components/common/vfg-field-custom-checklist.vue';
import vfgFieldCustomLookupChecklist from './components/common/vfg-field-custom-lookupchecklist.vue';
import vfgFieldCustomDatepicker from './components/common/vfg-field-custom-datepicker.vue';
import vfgFieldCustomMonthpicker from './components/common/vfg-field-custom-monthpicker.vue';
import vfgFieldCustomRichText from './components/common/vfg-field-custom-richtext.vue';
import vfgFieldCustomTextlist from './components/common/vfg-field-custom-textlist.vue';
import vfgFieldCustomYearpicker from './components/common/vfg-field-custom-yearpicker.vue';
import vfgFieldCustomSelect from './components/common/vfg-field-custom-select.vue';
import 'vue-form-generator/dist/vfg.css';
import 'vue-select/dist/vue-select.css';
import '../sass/vfg-overrides.scss';
import '../sass/base.scss';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { MsalPlugin } from './plugins/msal-plugin';

Vue.config.productionTip = false;
library.add(
  faBars,
  faBold,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faDownload,
  faItalic,
  faList,
  faListOl,
  faMinusCircle,
  faPen,
  faPlus,
  faPlusCircle,
  faSpinner,
  faStrikethrough,
  faTrash,
  faUnderline,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('field-customChecklist', vfgFieldCustomChecklist);
Vue.component('field-customLookupChecklist', vfgFieldCustomLookupChecklist);
Vue.component('field-customDatepicker', vfgFieldCustomDatepicker);
Vue.component('field-customMonthpicker', vfgFieldCustomMonthpicker);
Vue.component('field-customRichText', vfgFieldCustomRichText);
Vue.component('field-customTextlist', vfgFieldCustomTextlist);
Vue.component('field-customYearpicker', vfgFieldCustomYearpicker);
Vue.component('field-customSelect', vfgFieldCustomSelect);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

async function loadConfig() {
  // get the config file before moving on to anything else.  We need it for the
  // site to function
  await store.dispatch('fetchConfiguration');
  Vue.use(MsalPlugin, store);
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
}

Vue.use(VueFormGenerator, {
  validators: {
  },
});
configureFilters();

loadConfig();
